import React from 'react';
import styled from 'styled-components';

interface TelaApresentacaoProps {
  pesquisa: any;
  onNext: () => void;
}

const Container = styled.div`
  width: 100%;
  text-align: center;
  padding: 60px 40px;
  background: #ffffff;
  border-radius: 12px;
  margin: 20px 0;
`;

const Title = styled.h1`
  color: #222222;
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 20px;
  line-height: 1.2;
`;

const Subtitle = styled.div`
  color: #666;
  font-size: 18px;
  font-weight: 400;
  line-height: 1.6;
  margin-bottom: 40px;
  max-width: 700px;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  
  h1, h2, h3, h4, h5, h6 {
    color: #222222;
    margin: 20px 0 15px 0;
    font-weight: 600;
  }
  
  p {
    margin: 15px 0;
  }
  
  ul, ol {
    margin: 15px 0;
    padding-left: 25px;
    text-align: left;
  }
  
  li {
    margin: 8px 0;
  }
  
  strong {
    color: #222222;
    font-weight: 600;
  }
  
  em {
    font-style: italic;
  }
`;

const Button = styled.button<{ variant?: 'primary' | 'secondary' }>`
  border: none;
  padding: 16px 40px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.2s ease;
  width: 100%;
  max-width: 300px;
  
  ${props => props.variant === 'secondary' ? `
    background: #6c757d;
    color: #fff;
    
    &:hover {
      background: #5a6268;
    }
  ` : `
    background: #222222;
    color: #fff;
    
    &:hover {
      background: #333333;
    }
  `}
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
`;

const TelaApresentacao: React.FC<TelaApresentacaoProps> = ({ pesquisa, onNext }) => {
  const handleNext = () => {
    localStorage.removeItem('sessao_pesquisa');
    
    onNext();
    window.scrollTo(0, 0);
  };

  return (
    <Container>
      <Subtitle 
        dangerouslySetInnerHTML={{ 
          __html: pesquisa.texto_inicial || 'Bem-vindo ao nosso questionário de saúde. Suas respostas nos ajudarão a entender melhor suas necessidades e fornecer um atendimento mais personalizado.' 
        }} 
      />
      <ButtonContainer>
        <Button variant="primary" onClick={handleNext}>
          Iniciar Questionário
        </Button>
      </ButtonContainer>
    </Container>
  );
};

export default TelaApresentacao;
